<template>
  <div class="teachingActivity">
    <div class="selectCard">
      <div class="header"><img src="../../../assets/img/image/random.png" alt="">随机选人</div>
      <div class="selectPeople">
        <img  v-if="!selectPeopleName.s_name" src="../../../assets/img/image/select_bgc.png" alt="">
        <span v-else style="color: #333;font-weight: 700;font-size: 54px;">{{ selectPeopleName.s_name }}</span>
      </div>
      <div class="button" v-if="hideButton"><el-button @click="randomSelect()"><i class="iconfont" style="margin-right: 5px;">&#xe76a;</i>随机抽取</el-button><el-button style="background: #DD2E3D;" @click="resetSelect" ><i class="iconfont" style="margin-right: 5px;">&#xe769;</i>重置</el-button></div>
    </div>
  </div>
</template>
    
    <script>
export default {
  name: "teacherTextbook",
  components: {},
  props: ["hideButton"],
  data() {
    return {
      selectPeopleName: { s_name: "", s_id: void 0, length: void 0 },
      query: {},
    };
  },
  created() {
    this.query = JSON.parse(localStorage.getItem("query"));
    this.getSelectDetial()
  },

  methods: {
    randomSelect() {
      // 随机选取
      // jdTActivitiesSelect_personRand
      this.$shttp.axiosPost(
        this.$api.jdTActivitiesSelect_personRand,
        { id: this.query.id },
        (res) => {
          if (res.code === 200) {
            if (res.data.total != 0) {
              this.selectPeopleName.s_name =
                res.data.students[res.data.random_index].s_name;
              this.selectPeopleName.s_id =
                res.data.students[res.data.random_index].s_id;
              this.selectPeopleName.length = res.data.total;
            } else {
              this.selectPeopleName.length = res.data.total;
              this.$message.warning("当前班级暂无学生!")

            }
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    resetSelect() {
      // 重置
      this.$shttp.axiosPost(
        this.$api.jdTActivitiesSelect_personReset,
        { id: this.query.id },
        (res) => {
          if (res.code === 200) {
           
            this.selectPeopleName.s_name = "";
            this.selectPeopleName.s_id = void 0;
            this.selectPeopleName.length = void 0;
            this.$$message.success("重置成功");
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getSelectDetial(){
      this.$shttp.axiosPost(
        this.$api.jdTActivitiesSelect_personInfo,
        { id: this.query.id },
        (res) => {
          if (res.code === 200) {
            if (res.data.length == 0) return;
            this.selectPeopleName.s_name =res.data.student.s_name;
            this.selectPeopleName.s_id = res.data.student.s_id;
          
          }
        },
        (err) => {
          console.log(err);
        }
      );
    }
  },
};
</script>
    
    <style scoped lang="scss">
.teachingActivity {
  width: 100%;
  height: 100%;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  .selectCard {
 
    margin: 0 auto;
    margin-top: 50px;
    width: 426px;
    // height: 200px;
    // background: skyblue;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .header {
      margin-bottom: 20px;
      font-size: 22px;
      display: flex;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 32px;
      color: #333333;
      text-align: left;
      font-style: normal;
      text-transform: none;
      align-items: center;
      img {
        width: 32px;
        height: 32px;
        margin-right: 10px;
      }
    }
    .selectPeople {
      width: 426px;
      height: 263px;
      background: #f9f9f9;
      border-radius: 12px 12px 12px 12px;
      border: 1px solid #e8e8e8;
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .button {
      display: flex;
      .el-button {
        width: 185px;
        height: 38px;
        background: #006eff;
        border-radius: 8px 8px 8px 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
      }
    }
  }
}
</style>